@import '@alfalab/core-components-vars/src/safe-area.css';
@import '../../vars.css';

.footer {
    padding: var(--gap-20);

    @media (display-mode: standalone) {
        padding-bottom: calc(var(--sab) + var(--gap-20));
    }
}

.sticky {
    bottom: var(--gap-0);
}
